import React from 'react';
import { MESSAGE_MAX_LENGTH, MESSAGE_WARNING_LENGTH } from '../constants';
import { getCharCountClassName } from '../utils';

type Props = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
};

export const MessageTextarea = ({ value, onChange, placeholder = "メッセージを入力してください（URLを入力するとリンク名を設定できます）" }: Props) => {
  return (
    <div className="flex flex-col gap-[8px]">
      <label className="text-[14px] text-primary noto-sans-jp-medium">
        メッセージ内容
      </label>
      <div className="relative">
        <textarea
          className="border border-gray-300 rounded-[8px] p-[12px] h-[120px] resize-none text-[14px] noto-sans-jp-regular w-full"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={MESSAGE_MAX_LENGTH}
        />
        <span className={`absolute bottom-[8px] right-[12px] text-[11px] noto-sans-jp-regular pointer-events-none ${
          getCharCountClassName(value.length, MESSAGE_MAX_LENGTH, MESSAGE_WARNING_LENGTH)
        }`}>
          {value.length}/{MESSAGE_MAX_LENGTH}
        </span>
      </div>
    </div>
  );
}; 